module.exports = __webpack_public_path__ + "images/happy-outline7f31cd758f87addb537b3fb092323e2d.svg";